/**
 * Main reducers file, from which all existing reducer functions should
 * be combined.
 */

import { combineReducers } from 'redux';

import fileInput from 'components/FileInput/reducer';

import modals from 'components/Modals/reducer';

import setAsGoal from 'containers/SetAsGoal/store/reducer';

import counselor from 'reducers/counselor';
import googleTranslate from 'reducers/googleTranslate';
import notification from 'reducers/notification';
import snackbar from 'reducers/snackbar';
import staffProfile from 'reducers/staffProfile';
import user from 'reducers/user';
import userDevice from 'reducers/userDevice';

import accountabilitySystemAnalytics from 'modules/AccountabilitySystemAnalytics/K12Admin/store/reducer';
import accountabilitySystemSetup from 'modules/AccountabilitySystemSetup/K12Admin/store/reducer';
import accountSettings from 'modules/AccountSettings/reducer';
import accountSetupV2 from 'modules/AccountSetupV2/store/reducer';
import activityTaskExperience from 'modules/ActivityTaskExperience/reducer';
import alumni from 'modules/Alumni/store/reducer';
import alumniTakingSurveys from 'modules/AlumniTakingSurveys/reducer';
import analyticsHighlights from 'modules/AnalyticsHighlights/reducer';
import assessments from 'modules/Assessments/reducer';
import careerCenter from 'modules/CareerCenter/reducer';
import collegeCosts from 'modules/CollegeCosts/store/reducer';
import commonApp from 'modules/CommonApp/store/reducer';
import counselorDashboard from 'modules/CounselorDashboard/reducer';
import counselorMeetingScheduler from 'modules/CounselorMeetingScheduler/reducer';
import courseCatalog from 'modules/CourseCatalog/reducer';
import coursePlanListing from 'modules/CoursePlannerListing/reducer';
import coursePlanning from 'modules/CoursePlanning/reducer';
import coursePlanPreview from 'modules/CoursePlanPreview/reducer';
import dataIntegration from 'modules/DataIntegration/reducer';
import districtSettings from 'modules/DistrictSettings/reducer';
import documentCenter from 'modules/DocumentCenter/reducer';
import textToSpeech from 'modules/ElementaryCareers/store/reducer';
import eventScheduler from 'modules/EventSchedulerV2/store/reducer';
import experienceTracking from 'modules/ExperienceTracking/reducer';
import finalList from 'modules/FinalList/reducer';
import guardians from 'modules/Guardians/store/reducer';
import indicatorsV2 from 'modules/IndicatorsV2/reducer';
import ippmFilters from 'modules/IndustryPartnerProgramManagement/reducer';
import compoundIndicators from 'modules/KeyReadinessIndicators/reducer';
import studentLearningTasks from 'modules/LearningTasks/store/reducer';
import lifeSimulator from 'modules/LifeSimulator/store/reducer';
import loginMethods from 'modules/LoginMethods/store/reducer';
import mentorVideos from 'modules/MentorVideos/reducer';
import messageCenter from 'modules/MessageCenter/reducer';

import newsfeed from 'modules/Newsfeed/store/reducer';
import nonMasterCourseMapping from 'modules/NonMasterCourseMapping/reducer';
import allNotifications from 'modules/Notifications/allNotifications/reducer';
import notifications from 'modules/Notifications/reducer';
import opportunities from 'modules/Opportunities/reducer';
import orgMentorSetup from 'modules/OrgMentorSetup/reducer';
import pathwaySlots from 'modules/PathwaySelection/reducer';
import publicCourseCatalog from 'modules/PublicCourseCatalog/reducer';
import reportCenter from 'modules/ReportCenter/store/reducer';
import scholarships from 'modules/ScholarshipMatching/store/reducer';
import schoolSearch from 'modules/SchoolSearch/reducer';
import staffDashboard from 'modules/StaffDashboard/store/reducer';
import personalizedPlans from 'modules/StaffPersonalizedPlans/reducer';

import casefile from 'modules/StudentCasefile/reducer';
import studentDashboard from 'modules/StudentDashboard/store/reducer';
import studentDemoAccount from 'modules/StudentDemoAccount/reducer';
import studentGoals from 'modules/StudentGoals/reducer';
import studentPlanListing from 'modules/StudentPlanListing/reducer';
import studentProfile from 'modules/StudentProfile/reducer';
import studentScope from 'modules/StudentScopeFilter/reducer';
import studentSearch from 'modules/StudentSearchSidebar/reducer';
import surveyResults from 'modules/SurveyTask/reducer';

import welcomeWidget from 'modules/WelcomeWidget/reducer';

export default function createRootReducer() {
  return combineReducers({
    accountSettings,
    accountSetupV2,
    accountabilitySystemAnalytics,
    accountabilitySystemSetup,
    activityTaskExperience,
    allNotifications,
    alumni,
    alumniTakingSurveys,
    analyticsHighlights,
    assessments,
    careerCenter,
    casefile,
    collegeCosts,
    commonApp,
    compoundIndicators,
    counselor,
    counselorDashboard,
    counselorMeetingScheduler,
    courseCatalog,
    coursePlanListing,
    coursePlanPreview,
    coursePlanning,
    dataIntegration,
    districtSettings,
    documentCenter,
    experienceTracking,
    eventScheduler,
    fileInput,
    finalList,
    googleTranslate,
    guardians,
    indicatorsV2,
    ippmFilters,
    lifeSimulator,
    loginMethods,
    mentorVideos,
    messageCenter,
    modals,
    newsfeed,
    nonMasterCourseMapping,
    notification,
    notifications,
    opportunities,
    orgMentorSetup,
    pathwaySlots,
    personalizedPlans,
    publicCourseCatalog,
    reportCenter,
    scholarships,
    schoolSearch,
    setAsGoal,
    snackbar,
    staffDashboard,
    staffProfile,
    studentDashboard,
    studentDemoAccount,
    studentGoals,
    studentLearningTasks,
    studentPlanListing,
    studentProfile,
    studentScope,
    studentSearch,
    surveyResults,
    user,
    userDevice,
    welcomeWidget,
    textToSpeech,
  });
}
